import { api } from './api';

/** Public client configuration from GET /v1/config (no secrets). */
export interface ClientConfig { turnstileSiteKey: string | null; requireVerifiedEmailForCheckout: boolean; environment: string }

let cached: Promise<ClientConfig | null> | null = null;

/** Fetched once per page load; a failed fetch is retried on the next call. */
export function getConfig(): Promise<ClientConfig | null> {
  if (!cached) cached = api<ClientConfig>('/v1/config').catch(() => { cached = null; return null; });
  return cached;
}
